<template>
  <div class="dot" :style="{ top: top, right: right }">
    {{ productsCount || 0 }}
  </div>
</template>

<script>
/*eslint-disable*/
export default {
  name: 'ContactView ',
  props: {
    top: {
      type: String,
      default: '0px',
    },
    right: {
      type: String,
      default: '0px',
    },
    isSmall: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      productsCount: 0,
    };
  },
  methods: {
    GetCartProductsNumber() {
      const searchParams = {
        ...(this.$store.state.locationId ? { LocationId: this.$store.state.locationId } : ''),
        ...(this.$localStorageMethods.GetCartId()
          ? { CartId: this.$localStorageMethods.GetCartId() }
          : ''),
      };
      this.$axios
        .get(`/Order/${this.$utils.ApiNameByCurrentUser('getCartProductsNumber')}?${new URLSearchParams(searchParams)}`)
        .then((response) => {
          this.productsCount = response.data;
        })
        .catch(() => {
          this.$utils.ToastNotify('error', 'Something went wrong.');
        });
    },
  },
  mounted() {
    let self = this;
    this.GetCartProductsNumber();
    window.addEventListener('CartChangedEventBackend', function () {
      self.GetCartProductsNumber();
    });
  },
};
</script>
<style scoped>
.dot {
  border-radius: 50%;
  width: 16px;
  height: 16px;
  display: flex;
  justify-content: center;
  font-size: 10px;
  color: white;
  position: absolute;
  background-color: var(--primary-5);
  z-index: 1;
}
</style>
